import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllCostCenters = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/cost-centers',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveCostCenter = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/cost-centers',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateCostCenter = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/cost-centers/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteCostCenter = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/cost-centers/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllCostCenters,
  saveCostCenter,
  updateCostCenter,
  deleteCostCenter
}
